import React from "react";
import {CenteredDesign} from "../../../components/DesignSystem/CenteredDesign/CenteredDesign";
import {Card} from "antd";


export const CookiesPolicyPage = () => {

    return <CenteredDesign sm={16} lg={14}>

        <h1>Cookies Policy</h1>

        <p>
            This information applies to the use of the website https://www.apimoon.com/ operated by ApiMoon s.r.o., a company incorporated in the
            Czech Republic, ID No. 075 29 449, registered office: Na Korábě 2483/3, Libeň, 180 00 Prague 8, Czech Republic, registered with the
            Municipal Court in Prague, file No. C 302197 (hereinafter referred to as the “Operator” or “we”). If you need more information, you
            can contact us at our registered office or by e-mail at support@apimoon.com.
        </p>

        <h2>Cookies and other network identifiers</h2>

        <p>1. When you use our website, we and, with our permission, third parties store small identification files on your computer,
            collectively known as cookies, which allow us to recognise if you return to our website from the same device, remember some of your
            choices and allow us to verify whether you belong to a group that a certain advertising should be displayed to. A cookie is a small
            file of letters and numbers that we store in your internet browser or on your device’s hard drive. Some cookies allow us to link your
            browsing activities to our website from the moment you open your web browser window until you close it; others will remain on your
            device for a set period of time and will be activated each time you visit the website that created the particular cookie.</p>

        <p>2. We may also use measurement pixels or pixel tags (sometimes called web beacons), which are small images on a website that have a
            similar function to cookies and are designed to collect certain information from your device (such as its IP address or browser
            type). Unlike cookies, which are stored on your computer's hard drive, pixel tags are a fixed part of a website.</p>

        <p>3. For simplicity, we will refer to all of the above technologies as cookies in this document. We not only store cookies on your
            device, but we also read the cookies that our website has placed on your device; for simplicity, we will continue to refer to storage
            in this document.</p>
        <p>4. The Operator does not use any of the listed network identifiers to identify you as an individual by associating the identification
            or contact information it has about you with the identifier.</p>
        <p>5. We use cookies and other network identifiers for the purposes set out below, in particular to improve the functioning of our
            website and to display relevant advertising.</p>
        <p>6. Some cookies are placed on your device directly by our website. These cookies help us to:

            <ul>
                <li>a) identify you when you navigate between pages of our website and on return visits (for example, so that we can remember
                    your login from a particular device and not ask you repeatedly for your email and password);
                </li>
                <li>b) note that you have given your consent to us in accordance with this document;</li>
                <li>c) ensure security (for example, to investigate whether someone has misused your connection to our website);</li>
                <li>d) record, investigate and fix malfunctions and non-functioning parts of our website.</li>
            </ul>

        </p>
        <p>7. Such cookies and other files are necessary for the proper functioning of our website. If you block these cookies in your browser,
            our website may not function properly and as a result we may not be able to provide you with our products and services. We will only
            inform you about the use of these cookies.
        </p>
        <p>8. Based on your consent, we may also store the following analytical or preference cookies from our website on your device which
            allow us to:


            <ul>
                <li>a) monitor traffic to our website, its individual pages, create statistics and reports and measure the effectiveness of
                    advertising;
                </li>
                <li>b) show you different versions of our website when we are testing new functionality;</li>
                <li>c) customize the content of our website for you, for example, to show you preferentially the products you have already viewed
                    and to show you other tailored offers on our website.
                </li>
            </ul>

        </p>

        <p>9. Based on your consent, we may also allow third parties to place marketing cookies on your device, which may use them for the
            following purposes:

            <li>a) to collect data about your behaviour on our website and other websites;</li>
            <li>b) to display customised offers and targeted advertising within advertising networks on websites other than our website;</li>
            <li>c) to connect with social networks such as Facebook, including automatically logging in, providing features such as the "Like"
                button, and displaying customized offers and targeted advertising on these social networks and websites other than our website.
            </li>

        </p>

        <p>10. You can enable or disable the storage of these cookies when you visit https://www.apimoon.com/.</p>

        <p>11. We do not only obtain data about your behaviour on the website from cookies. We also supplement it with certain other data such as
            (i) the IP address of your device, (ii) the MAC address, (iii) the operating system of your device, its version and language
            settings, (iv) the browser you are using on your device, its version and language settings, and (v) the address of the website (URL)
            from which you are accessing our website.</p>


        <p>
            2. We process this data about your behaviour on the website on the basis of our legitimate interest, which is:


            <ul>
                <li>a) to improve our services to you if the purpose of the processing is to obtain information that will enable us to improve
                    the website for you in the future;
                </li>
                <li>b) measuring the effectiveness of our website and advertising costs, if the purpose of the processing is to generate
                    statistics and reports, in particular to monitor traffic to our website, its individual pages and to measure the
                    effectiveness of advertising;
                </li>
                <li>c) the smooth functionality of our services, if the purpose of the processing is to test new functions and applications
                    before implementation (in particular to prevent problems with the functionality of these innovations in actual operation);
                </li>
                <li>d) the smooth functionality of our services and the security of your data, if the purpose of the processing is to prevent
                    attacks on our website and threats to its functionality and the security of your data.
                </li>
            </ul>
        </p>

        <p>13. We use the data for these purposes for a period of 12 months. You have the right to object to this processing.</p>

        <p>14. We may also use information about your web behaviour to personalise our website and display targeted advertising, and we may also
            pass this information to social and advertising network operators for the purpose of displaying targeted advertising.</p>

        <p>
            15. All standard browsers allow you to manage whether cookies will be stored on your computer and allow you to delete cookies already
            stored.
        </p>

        <p>
            16. If you have cookies enabled and you visit our website, the use of cookies is governed by this information and the rules of the
            operators of each system set out below.
        </p>

        <p>17. Some cookies and other network identifiers on our website are operated in whole or in part by third parties. These parties have
            their own terms and conditions governing the use of network identifiers. Please read these policies as well:For more information on
            Google’s policy, <a href={"https://policies.google.com/technologies/ads"} target={"_blank"}>click here</a>.</p>

        <h2>Your rights</h2>

        <p>
            To the extent that cookies are personal data, data protection legislation guarantees you various data protection rights: to the
            extent that the data protection regulations - in particular the GDPR - guarantee you this, you can request access to your personal
            data (i.e. information about what specific data we are working with and how we are working with it), limit the processing of your
            data (i.e. we will not delete the data for the time being, but we will not work with it) and correct and delete it (always if the
            legal conditions for this are met), you can object to the processing and you can exercise your right to data portability. To exercise
            any of these rights, please contact us using the contact details above - the easiest way to do this is to send us an email and we
            will be happy to help you exercise your rights. If you believe that we are violating the law by processing your personal data, you
            can file a complaint with the national supervisory authority (for the Czech Republic it is the Office for Personal Data Protection
            www.uoou.cz).
        </p>

    </CenteredDesign>

}